import React from "react";
import { X, MapPin, CalendarClock, Cloud, Trash2, ArrowRight, AlertTriangle, UserRoundCheck } from "lucide-react";

const fmt = (d) => d.toLocaleString("fr-FR", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" });
const INTV_STATUS = { planifiee: "Planifiée", en_cours: "En cours", terminee: "Terminée" };

const EventDetail = ({ e, onClose, onDeleteRdv, onGoInterventions, onReplace }) => {
  const r = e.raw;
  const Icon = e.kind === "intervention" ? MapPin : e.kind === "dolibarr" ? Cloud : CalendarClock;
  return (
    <div className={`bg-white border rounded-xl p-4 mb-4 flex items-start gap-3 ${r.needs_reassign ? "border-red-300" : "border-neutral-200"}`} data-testid="agenda-event-detail">
      <div className="bg-brand/10 text-brand rounded-lg p-2.5"><Icon size={18} /></div>
      <div className="flex-1 min-w-0">
        <p className="font-semibold text-neutral-900">{e.title}</p>
        <p className="text-sm text-neutral-600">{fmt(e.start)} · {e.hours} h</p>
        {e.kind === "intervention" && (
          <p className="text-sm text-neutral-500 mt-1">
            {INTV_STATUS[r.status] || r.status} · {[r.adresse, r.ville].filter(Boolean).join(", ") || "adresse non renseignée"}
            {r.collaborateur_nom && ` · Équipe : ${r.collaborateur_nom}`}
            {r.gps_alert && <span className="text-red-600 font-semibold"> · pointage hors zone</span>}
          </p>
        )}
        {e.kind === "intervention" && r.needs_reassign && <p className="text-sm text-red-600 font-semibold mt-1 flex items-center gap-1" data-testid="agenda-detail-needs-reassign"><AlertTriangle size={13} /> À réaffecter — {r.reassign_reason}</p>}
        {e.kind === "rdv" && r.notes && <p className="text-sm text-neutral-500 mt-1">{r.notes}</p>}
        <p className="text-xs mt-1">
          {r.dolibarr_event_id ? <span className="text-emerald-600">✓ Synchronisé Dolibarr #{r.dolibarr_event_id}</span>
            : e.kind === "dolibarr" ? <span className="text-neutral-500">Événement Dolibarr (lecture seule)</span>
            : <span className="text-amber-600">Non synchronisé{r.dolibarr_error ? ` · ${r.dolibarr_error.slice(0, 80)}` : ""}</span>}
        </p>
        <div className="flex items-center gap-3 mt-2">
          {e.kind === "intervention" && onReplace && r.status !== "terminee" && (
            <button onClick={() => onReplace(r)} className={`text-sm flex items-center gap-1 ${r.needs_reassign ? "text-red-600 font-semibold" : "text-brand"} hover:underline`} data-testid="agenda-replace-easer"><UserRoundCheck size={13} /> {r.needs_reassign ? "Affecter un remplaçant" : "Remplacer un easer"}</button>
          )}
          {e.kind === "intervention" && onGoInterventions && (
            <button onClick={onGoInterventions} className="text-sm text-brand hover:underline flex items-center gap-1" data-testid="agenda-goto-interventions">Gérer dans Interventions <ArrowRight size={13} /></button>
          )}
          {e.kind === "rdv" && (
            <button onClick={() => onDeleteRdv(r.id)} className="text-sm text-red-600 hover:underline flex items-center gap-1" data-testid="agenda-delete-rdv"><Trash2 size={13} /> Supprimer le RDV</button>
          )}
        </div>
      </div>
      <button onClick={onClose} className="text-neutral-400 hover:text-neutral-700" data-testid="agenda-detail-close"><X size={16} /></button>
    </div>
  );
};

export default EventDetail;
